// import React, { useContext, useEffect, useState } from 'react'
// import Filters from './Filters';
// import { BasePopupContext } from '../../hooks/usePopup';
// import { customStringify } from '../../utils';
// import axios from 'axios';
// import useApi from "../../hooks/useApi";
// import { network_tl } from '../../translations';
// import RetryApi from '../../components/RetryApi';
// import { DESENDING_ORDER, INSTAGRAM, LISTING_LIMIT, ORDER_DESCENDING, POPUP_SMALL } from '../../constants';
// import { FormattedMessage, useIntl } from 'react-intl';
// import _ from 'lodash';
// import Card from './Card';
// import Pagination from '../../components/Pagination';
// import Loading from '../../components/Loading';
// import { FaCrown } from 'react-icons/fa6';
// import { Link } from 'react-router-dom';
// import { UpdatePlan } from '../../components/UpdatePlan';
// import { useSelector } from 'react-redux';

// const Container = () => {
//   const [filters, setFilters] = useState({
//     search: "",
//     city: "",
//     platform: "",
//     niche: "",
//     min_followers: "",
//     max_followers: "",
//     min_engagement_rate: "",
//     max_engagement_rate: "",
//     sort_order: ORDER_DESCENDING
//   })

//   useEffect(() => {
//     console.log("filters", filters)
//   }, [filters])

//   const [appliedFilters, setAppliedFilters] = useState({
//     search: "",
//     city: "",
//     niche: "",
//     platform: "",
//     min_followers: "",
//     max_followers: "",
//     min_engagement_rate: "",
//     max_engagement_rate: "",
//     sort_order: ORDER_DESCENDING
//   })

//   const { setPopup } = useContext(BasePopupContext);

//   const [data, setData] = useState([])
//   let offset = 0;
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(false);
//   const [count, setCount] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
//   const user = useSelector(state => state.user);

//   const intl = useIntl();
//   const { Axios } = useApi();

//   const getData = async (curr) => {
//     try {
//       setLoading(true);
//       setError(false);

//       if (curr) {
//         offset = 0;
//       }
//       else if (count) {
//         offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
//       } else {
//         offset = 0;
//       }
//       const result = await Axios.get(`api/influencer?limit=${LISTING_LIMIT}&offset=${offset}&search=${appliedFilters.search}&city=${filters.city ? filters.city : ""}&${filters.platform.value === INSTAGRAM ? "min_instagram_followers" : "min_tiktok_followers"}=${filters.min_followers ? filters.min_followers : ""}&${filters.platform.value === INSTAGRAM ? "max_instagram_followers" : "max_tiktok_followers"}=${filters.max_followers ? filters.max_followers : ""}&${filters.platform.value === INSTAGRAM ? "min_instagram_engagement_rate" : "min_tiktok_engagement_rate"}=${filters.min_engagement_rate ? filters.min_engagement_rate : ""}&${filters.platform.value === INSTAGRAM ? "max_instagram_engagement_rate" : "max_tiktok_engagement_rate"}=${filters.max_engagement_rate ? filters.max_engagement_rate : ""}&niche=${filters.niche ? filters.niche.value : ""}&platform=${filters.platform ? filters.platform.value : ""}&sort_order=${filters.sort_order ? filters.sort_order : ORDER_DESCENDING}`);
//       setData(result.data.payload);
//       setLoading(false);
//       setCount(result.data.count)
//     } catch (e) {
//       if (axios.isCancel(e)) {

//       } else if (e.response) {
//         setError(customStringify(e.response.data.description))
//         setLoading(false)
//       } else {
//         setError(network_tl(intl))
//         setLoading(false)
//       }
//     }
//   }

//   useEffect(() => {
//     getData()
//   }, [currentPage, sort])

//   useEffect(() => {
//     getData(1)
//   }, [appliedFilters.search, filters.city, filters.min_followers, filters.max_followers, filters.min_engagement_rate, filters.max_engagement_rate, filters.niche, filters.platform, filters.sort_order])

//   const applyFilters = () => {
//     const copy = _.cloneDeep(filters)
//     setCurrentPage(1);
//     setAppliedFilters(copy)
//   }

//   const resetFilters = () => {
//     setCurrentPage(1)
//     setFilters({
//       search: "",
//       city: "",
//       niche: "",
//       min_followers: "",
//       max_followers: "",
//       platform: "",
//       min_engagement_rate: "",
//       max_engagement_rate: "",
//       sort_order: ORDER_DESCENDING
//     })
//     setAppliedFilters({
//       search: "",
//       city: "",
//       niche: "",
//       min_followers: "",
//       max_followers: "",
//       platform: "",
//       min_engagement_rate: "",
//       max_engagement_rate: "",
//       sort_order: ORDER_DESCENDING
//     })
//   }

//   const refreshListing = () => {
//     setCurrentPage(1);
//     getData(1)
//   }
//   return (
//     <div className='container'>
//       <h1 className='text-[40px] mx-auto w-[60%] text-center font-semibold leading-none py-14'>
//         <FormattedMessage id="discover_title" defaultMessage={"Discover the world’s top influencers"} />
//       </h1>
//       <Filters
//         filters={filters}
//         setFilters={setFilters}
//         applyFilters={applyFilters}
//         resetFilters={resetFilters}
//         appliedFilters={appliedFilters}
//         setAppliedFilters={setAppliedFilters}
//       />


//       <div className='mt-12 py-5 transition-all duration-1000'>
//         {loading ?
//           <div className='flex justify-center'>
//             <Loading />
//           </div> :
//           error ?
//             <>
//               <RetryApi error={error} retry={getData} />
//             </>
//             :

//             <>
//               {(data.length > 0) ? (
//               user?.free_subscription?.is_paid !== "free" ?
//             <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2k:grid-cols-5  gap-5 justify-items-center'>
//                 {data.map((item, index) => (

//                   <Card item={item} key={index}/>

//                 ))}
//             </div>
//             : 
//             <>
//             <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2k:grid-cols-5 gap-5 justify-items-center'>
//               {data.map((item, index) => {
//                 const globalIndex = (currentPage - 1) * LISTING_LIMIT + index;
//                 const isBlurred = globalIndex >= 4;


//                 return (
//                   <Card item={item} isBlurred={isBlurred} key={index} />
//                 );
//               })}
//             </div>

//             {(currentPage >= 1) && (
//               <UpdatePlan />
//             )}
//           </>
//                 ) 

//                 : (
//                   <p className="text-t-light flex justify-center w-full mt-5">
//                     <FormattedMessage id="no_influencers_found" defaultMessage="No Influencers Found" />
//                   </p>
//                 )}
//               <div className="flex my-10 justify-end">
//                 <Pagination
//                   currentPage={currentPage}
//                   setCurrentPage={setCurrentPage}
//                   perPage={LISTING_LIMIT}
//                   offset={offset}
//                   total_pages={Math.ceil(count / LISTING_LIMIT)}
//                   count={count} />
//               </div></>
//         }



//       </div>
//     </div>
//   )
// }

// export default Container


import React, { useContext, useEffect, useState } from 'react';
import Filters from './Filters';
import { BasePopupContext } from '../../hooks/usePopup';
import { customDiscoveryTableStyles, customStringify, customTableStyles } from '../../utils';
import axios from 'axios';
import useApi from "../../hooks/useApi";
import { network_tl } from '../../translations';
import RetryApi from '../../components/RetryApi';
import { CATEGORIES, DESENDING_ORDER, INSTAGRAM, LISTING_LIMIT, ORDER_DESCENDING } from '../../constants';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import DataTable from 'react-data-table-component';
import Pagination from '../../components/Pagination';
import Loading from '../../components/Loading';
import { Link } from 'react-router-dom';
import { UpdatePlan } from '../../components/UpdatePlan';
import { useSelector } from 'react-redux';
import { formatFollowers } from '../../utils';
import { GrInstagram } from 'react-icons/gr';
import { FaTiktok } from 'react-icons/fa6';
import WishList from '../InfluencerDetail/WishList';

const Container = () => {
  const [filters, setFilters] = useState({
    search: "",
    city: "",
    type: "",
    platform: "",
    niche: "",
    min_followers: "",
    max_followers: "",
    min_engagement_rate: "",
    max_engagement_rate: "",
    sort_order: ORDER_DESCENDING
  })

  useEffect(() => {
    console.log("filters", filters)
  }, [filters])

  const [appliedFilters, setAppliedFilters] = useState({
    search: "",
    city: "",
    type: "",
    niche: "",
    platform: "",
    min_followers: "",
    max_followers: "",
    min_engagement_rate: "",
    max_engagement_rate: "",
    sort_order: ORDER_DESCENDING
  })

  const { setPopup } = useContext(BasePopupContext);

  const [data, setData] = useState([])
  let offset = 0;
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
  const user = useSelector(state => state.user);

  const intl = useIntl();
  const { Axios } = useApi();

  const getData = async (curr) => {
    try {
      setLoading(true);
      setError(false);

      if (curr) {
        offset = 0;
      }
      else if (count) {
        offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
      } else {
        offset = 0;
      }
      const result = await Axios.get(`api/influencer?recommendation=true&limit=${LISTING_LIMIT}&offset=${offset}`);
      setData(result.data.payload);
      setLoading(false);
      setCount(result.data.count)
    } catch (e) {
      if (axios.isCancel(e)) {

      } else if (e.response) {
        setError(customStringify(e.response.data.description))
        setLoading(false)
      } else {
        setError(network_tl(intl))
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    getData()
  }, [currentPage, sort])

  useEffect(() => {
    getData(1)
  }, [appliedFilters.search, filters.city, filters.type, filters.min_followers, filters.max_followers, filters.min_engagement_rate, filters.max_engagement_rate, filters.niche, filters.platform, filters.sort_order])

  const applyFilters = () => {
    const copy = _.cloneDeep(filters)
    setCurrentPage(1);
    setAppliedFilters(copy)
  }

  const resetFilters = () => {
    setCurrentPage(1)
    setFilters({
      search: "",
      city: "",
      type: "",
      niche: "",
      min_followers: "",
      max_followers: "",
      platform: "",
      min_engagement_rate: "",
      max_engagement_rate: "",
      sort_order: ORDER_DESCENDING
    })
    setAppliedFilters({
      search: "",
      type: "",
      city: "",
      niche: "",
      min_followers: "",
      max_followers: "",
      platform: "",
      min_engagement_rate: "",
      max_engagement_rate: "",
      sort_order: ORDER_DESCENDING
    })
  }


  const refreshListing = () => {
    setCurrentPage(1);
    getData(1)
  }

  const columns = [
    {
      name: <></>,
      selector: row => row.user?.name,
      // sortable: true,
      wrap: true,
      width: '50px',


      cell: row => (
        <div className={`pl-2 flex items-center gap-2 py-2 ${row.isBlurred ? "blur-sm select-none" : ""}`}>
          <WishList id={row.id} isWishlisted={row.whislist} isDisabled={row.isBlurred} />
          {/* <WishList id={row.id} isWishlisted={row?.latest_agency_status?.is_active} WishListId={row?.latest_agency_status?.wishlist_id} isDisabled={row.isBlurred}/> */}
        </div>
      )
    },
    {
      name: <div className='min-w-[400px]'><FormattedMessage id="influencer" defaultMessage={"Influencer"} /></div>,
      selector: row => row.user?.name,
      // sortable: true,
      wrap: true,


      cell: row => (
        <div className={` flex items-center gap-2 py-2 ${row.isBlurred ? "blur-sm select-none" : ""}`}>
          <div
            className="min-w-14 w-14 min-h-14 h-14 rounded-full bg-gray-200 bg-cover bg-center"
            style={{ backgroundImage: `url(${row.user?.picture || "/images/avatar.png"})` }}
          ></div>


          <div>
            {
              row.isBlurred ?
                <p className='text-gray-900  font-medium text-sm'>{row.user?.name} {row.user?.sur_name}</p>
                :
                <Link
                  to={`/influencer/${row.id}`}
                  className="text-gray-900 hover:text-primary font-medium text-sm"
                >
                  {row.user?.name} {row.user?.sur_name}
                </Link>
            }
          </div>
        </div>
      )
    },
    {
      name: <><FormattedMessage id="followers" defaultMessage={"Followers"} /></>,
      selector: row => row.instagram_followers || row.tiktok_followers,
      wrap: true,

      cell: row => (
        // <span className={`text-sm font-medium ${row.isBlurred ? "blur-sm select-none " : ""}`}>
        //   {formatFollowers(row.instagram_followers || row.tiktok_followers)}
        // </span>

        <div className={`text-sm font-medium ${row.isBlurred ? "blur-sm select-none " : ""}`}>
          {
            row.instagram_followers > 0 &&
            <div className='inline-flex space-x-1 items-center'>
              <GrInstagram className='text-sm text-gray-500' />
              <span>{formatFollowers(row.instagram_followers)}</span>
            </div>
          }
          {
            row.tiktok_followers > 0 &&
            <div>
              <div className='inline-flex space-x-1 items-center'>
                <FaTiktok className='text-sm text-gray-500' />
                <span>{formatFollowers(row.tiktok_followers)}</span>
              </div>
            </div>
          }
          {
            row?.instagram_followers === 0 && row?.tiktok_followers === 0 &&
            <div className='inline-flex space-x-1 items-center'>
              <GrInstagram className='text-sm text-gray-500' />
              <span>0</span>
            </div>
          }
        </div>
      )
    },
    {
      name: <><FormattedMessage id="engagement" defaultMessage={"Engagement"} /></>,
      selector: row => row.engagement_rate,
      wrap: true,

      cell: row => (
        // <span className={`text-sm font-medium ${row.isBlurred ? "blur-sm" : ""}`}>
        //   {row.engagement_rate || '0%'}
        // </span>
        <div className={`text-sm font-medium ${row.isBlurred ? "blur-sm select-none " : ""}`}>
          {
            row.instagram_followers > 0 &&
            <div className='inline-flex space-x-1 items-center'>
              <GrInstagram className='text-sm text-gray-500' />
              <span>{formatFollowers(row.instagram_engagement_metrics)}%</span>
            </div>
          }
          {
            row.tiktok_followers > 0 &&
            <div>
              <div className='inline-flex space-x-1 items-center'>
                <FaTiktok className='text-sm text-gray-500' />
                <span>{formatFollowers(row.tiktok_engagement_metrics)}%</span>
              </div>
            </div>
          }
          {
            row?.instagram_followers === 0 && row?.tiktok_followers === 0 &&
            <div className='inline-flex space-x-1 items-center'>
              <GrInstagram className='text-sm text-gray-500' />
              <span>0%</span>
            </div>
          }
          </div>
      )
    },
    {
      name: <><FormattedMessage id="niche" defaultMessage={"Niche"} /></>,
      selector: row => row.engagement_rate,
      wrap: true,

      cell: row => (
        // <span className={`text-sm font-medium ${row.isBlurred ? "blur-sm" : ""}`}>
        //   {row.engagement_rate || '0%'}
        // </span>
        <div className={`text-sm font-medium ${row.isBlurred ? "blur-sm select-none " : ""}`}>
          {row.niches && row.niches.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {row.niches.slice(0, 2).map((niche, index) => (
                <span
                  key={index}
                  className="rounded-full text-xs text-white bg-secondary py-1 px-3"
                >
                  {CATEGORIES.find((row) => row.value === niche)?.label ? CATEGORIES.find((row) => row.value === niche)?.label : niche}
                </span>
              ))}
              {row.niches.length > 2 && (
                <span className="rounded-full text-xs text-white bg-secondary py-1 px-3">
                  +{row.niches.length - 2}
                </span>
              )}
            </div>
          )}</div>
      )
    },
    {
      name: <><FormattedMessage id="location" defaultMessage={"Location"} /></>,
      selector: row => row.user?.city,
      wrap: true,


      cell: row => (
        <span className={`text-sm text-gray-600 ${row.isBlurred ? "blur-sm select-none " : ""}`}>
          {`${row.user?.country || ''}${row.user?.country && row.user?.city ? ', ' : ''}${row.user?.city || ''}${row.user?.state ? `, ${row.user?.state}` : ''}`}
        </span>
      )
    }
  ];



  return (
    <div className='container'>
      <div className='mt-14 mb-8  '>
      <h1 className='text-[40px] mx-auto w-[60%] text-center font-semibold leading-none mb-2'>
        <FormattedMessage id="ai_recommendations" defaultMessage={"AI Recommendations"} />
      </h1>
      <h1 className='text-[20px] mx-auto w-[60%] text-center font-semibold leading-none'>
        <FormattedMessage id="ai_recommendations_desc" defaultMessage={"Discover Your Perfect Match"} />
      </h1>
      </div>
      {/* <Filters
        filters={filters}
        setFilters={setFilters}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
      /> */}

      <div className='mt-12 container py-5'>
        {loading ? (
          <div className='flex justify-center'>
            <Loading />
          </div>
        ) : error ? (
          <RetryApi error={error} retry={getData} />
        ) : (
          <>
            {data.length > 0 ? (
              <DataTable
                columns={columns}
                data={ data
                  // user?.free_subscription?.is_paid !== "free"
                  //   ? 
                  //   data
                  //   : data.map((item, index) => ({
                  //     ...item,
                  //     isBlurred: (currentPage - 1) * LISTING_LIMIT + index >= 1
                  //   }))
                }
                pagination={false}
                customStyles={customDiscoveryTableStyles}

                noDataComponent={
                  <p className="text-t-light py-10">
                    <FormattedMessage id="no_influencers_found" defaultMessage="No Influencers Found" />
                  </p>
                }
              />
            ) : (
              <p className="text-t-light flex justify-center w-full mt-5">
                <FormattedMessage id="no_influencers_found" defaultMessage="No Influencers Found" />
              </p>
            )}
            {/* {user?.free_subscription?.is_paid === "free" && data.length > 0 && currentPage >= 1 && (
              <UpdatePlan />
            )} */}
            {data.length > 0 && (
              <div className="flex my-10 justify-end">
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  perPage={LISTING_LIMIT}
                  offset={offset}
                  total_pages={Math.ceil(count / LISTING_LIMIT)}
                  count={count}
                />
              </div>
            )}

          </>
        )}
      </div>
    </div>
  );
};

export default Container;